import { render } from "./PublishDialog.vue?vue&type=template&id=6d25f020&scoped=true"
import script from "./PublishDialog.vue?vue&type=script&lang=js"
export * from "./PublishDialog.vue?vue&type=script&lang=js"

import "./PublishDialog.vue?vue&type=style&index=0&id=6d25f020&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d25f020"]])

export default __exports__